/* eslint-disable sonarjs/no-duplicate-string */

import type { CustomBannerConfig } from "../types";

export const customBannerConfig: CustomBannerConfig = {
  bottom: {
    aspectRatio: 492 / 320,
  },
  app_home_main: {
    translation: "beFirst",
    qrcode: "qrcode-app_home_main.png",
    storeUrl: "https://app.adjust.com/1rge5qzo_1rhb5wwu",
    NewLayoutStoreUrl: "https://immowelt.go.link?adj_t=1udgh1gy_1umf10i8",
  },
  app_serp: {
    translation: "beFirst",
    qrcode: "qrcode-app_serp.png",
    storeUrl: "https://app.adjust.com/1rjcv85p_1rujoas3",
    NewLayoutStoreUrl: "https://immowelt.go.link?adj_t=1u5dphid_1ub5zxoi",
  },
  app_serp_map: {
    translation: "beFirst",
    qrcode: "qrcode-app_serp.png",
    storeUrl: "https://app.adjust.com/1rjcv85p_1rujoas3",
  },
  app_serp_project: {
    translation: "beFirst",
    qrcode: "qrcode-app_serp.png",
    storeUrl: "https://app.adjust.com/1rjcv85p_1rujoas3",
  },
  app_cldp: {
    translation: "continue",
    qrcode: "qrcode-app_cldp.png",
    storeUrl: "https://app.adjust.com/1r6445ba_1ryfh48w",
    NewLayoutStoreUrl: "https://immowelt.go.link?adj_t=1u48t9lh_1u8u7i0o",
  },
  app_conp_dashboard: {
    translation: "easier",
    qrcode: "qrcode-app_conp_dashboard_and_estimation_page.png",
    storeUrl: "https://app.adjust.com/1rer0hle_1rifqrco",
  },
  app_conp_estimationPage: {
    translation: "easier",
    qrcode: "qrcode-app_conp_dashboard_and_estimation_page.png",
    storeUrl: "https://app.adjust.com/1rer0hle_1rifqrco",
  },
  app_conp_seeker: {
    translation: "easier",
    qrcode: "qrcode-app_conp_seeker.png",
    storeUrl: "https://app.adjust.com/1r6b7pgs_1r8op052",
  },
  app_ssal_savedSearchManagement: {
    translation: "alerts",
    qrcode: "qrcode-app_ssal_saved_search.png",
    storeUrl: "https://app.adjust.com/1rbhqrq6_1ri0u7lk",
  },
  app_ssal_savedSearchUnsubscribed: {
    translation: "alerts",
    qrcode: "qrcode-app_ssal_saved_search.png",
    storeUrl: "https://app.adjust.com/1rbhqrq6_1ri0u7lk",
  },
  app_owcl_contact: {
    translation: "dontMiss",
    qrcode: "qrcode-app_owcl.png",
    storeUrl: "https://app.adjust.com/1r7ebztz_1rcany8x",
  },
  app_owcl_myListings: {
    translation: "dontMiss",
    qrcode: "qrcode-app_owcl.png",
    storeUrl: "https://app.adjust.com/1r7ebztz_1rcany8x",
  },
  app_esfu_estimaLandingPage: {
    translation: "follow",
    qrcode: "qrcode-app_esfu_estima_landing_page.png",
    storeUrl: "https://app.adjust.com/1rpktb61_1rvjo5jl",
  },
};
